import { render, staticRenderFns } from "./IllustrationFrameworksSection.vue?vue&type=template&id=b05e6032"
import script from "./IllustrationFrameworksSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationFrameworksSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationFrameworksSection.vue?vue&type=style&index=0&id=b05e6032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports